import React from 'react';
import { Helmet } from "react-helmet-async";
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

const Institucional = () => {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Helmet>
        <title>Institucional | Save Energy</title>
      </Helmet>
      
      <NavBar />

      <main className="flex-1">
        {/* 1 - CABEÇALHO com o video nativo sem zoom */}
        <div className="w-full overflow-hidden bg-black flex justify-center">
          <video 
            autoPlay 
            loop 
            muted 
            playsInline 
            className="w-full h-auto block"
          >
            <source src="/media/institucional/cabeçalho.mp4" type="video/mp4" />
          </video>
        </div>

        {/* 2 - Container da primeira img e 1° texto */}
        <div className="w-full py-20 px-4 bg-white flex justify-center">
          <div className="max-w-6xl w-full flex flex-col md:flex-row gap-10 items-center text-left">
            <div className="w-full md:w-1/2 pr-0 md:pr-4">
              <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
                <span className="text-gray-500">Luz que valoriza</span><br />
                <span className="text-[#3c1053]">cada detalhe</span><br />
                <span className="text-gray-500">do seu projeto</span>
              </h1>
              <p className="text-gray-600 text-lg md:text-xl font-light leading-relaxed text-justify">
                Somos uma fabricante brasileira de iluminação LED para quem exige qualidade, inovação e performance. 
                Estamos há mais de 10 anos desenvolvendo soluções para lojistas, distribuidores, arquitetos e profissionais de iluminação.
              </p>
            </div>
            <div className="w-full md:w-1/2 flex justify-center md:justify-end">
              <img src="/media/institucional/1.jpg" alt="Fábrica 1" className="w-full max-w-lg shadow-xl object-cover" />
            </div>
          </div>
        </div>

        {/* 3 - Container da segunda img e 2° texto */}
        <div className="w-full py-20 px-4 bg-gray-50 flex justify-center">
          <div className="max-w-6xl w-full flex flex-col md:flex-row gap-12 items-center">
            <div className="w-full md:w-1/2 flex justify-center md:justify-start">
               <img src="/media/institucional/2.jpg" alt="Nossa Essência" className="w-full max-w-lg object-cover shadow-md" />
            </div>
            <div className="w-full md:w-1/2 text-left">
              <h2 className="text-gray-600 text-3xl md:text-4xl font-bold mb-2">Nossa essência<br />está na inovação</h2>
              <h3 className="text-gray-500 text-xl font-medium mb-6">Tecnologia própria que gera confiança</h3>
              <p className="text-gray-700 text-base leading-relaxed text-justify">
                Na SAVEENERGY, inovação não é apenas um conceito, faz parte do nosso processo de desenvolvimento. 
                Investimos continuamente em engenharia, pesquisa e desenvolvimento para criar soluções exclusivas que elevem o 
                desempenho e a durabilidade dos nossos produtos.
              </p>
            </div>
          </div>
        </div>

        {/* 4 - Container proshield */}
        <div className="w-full py-20 px-4 flex justify-center bg-white">
          <div className="w-full max-w-6xl bg-gray-50 p-10 rounded-3xl shadow-sm border border-gray-100 group hover:bg-[#890083] transition-colors duration-300">
            <div className="flex flex-col md:flex-row gap-10 items-start">
                <div className="flex flex-col gap-6 w-full md:w-1/3 items-center">
                  <img src="/media/institucional/3.png" alt="Proshield UV" className="w-24 object-contain group-hover:hidden" />
                  <img src="/media/institucional/prosh_2.png" alt="Proshield UV" className="w-24 object-contain hidden group-hover:block" />
                  <img src="/media/institucional/4.jpg" alt="Pellets" className="w-full h-auto rounded-xl object-cover shadow-md" />
                </div>
                <div className="w-full md:w-2/3 text-left">
                  <h4 className="text-[#890083] group-hover:text-white font-bold text-2xl mb-4 transition-colors text-justify">PROSHIELD UV | Tecnologia exclusiva e patenteada pela SAVEENERGY</h4>
                  <p className="text-gray-600 group-hover:text-gray-100 text-base mb-6 transition-colors text-justify">
                    Proteção permanente contra a radiação ultravioleta desenvolvida para preservar a aparência, a resistência 
                    mecânica e durabilidade dos componentes ao longo dos anos.
                  </p>
                  <div className="flex flex-col gap-3">
                    <span className="font-bold text-[#3c1053] text-lg group-hover:text-white transition-colors">Benefícios:</span>
                    <ul className="flex flex-col gap-3 text-gray-600 group-hover:text-gray-100 text-base transition-colors text-left">
                      <li className="flex items-center gap-3">
                        <img src="/media/institucional/check.png" alt="check" className="w-5 h-5 group-hover:hidden" />
                        <img src="/media/institucional/check_2.png" alt="check" className="w-5 h-5 hidden group-hover:block" />
                        Evita o amarelamento precoce
                      </li>
                      <li className="flex items-center gap-3">
                        <img src="/media/institucional/check.png" alt="check" className="w-5 h-5 group-hover:hidden" />
                        <img src="/media/institucional/check_2.png" alt="check" className="w-5 h-5 hidden group-hover:block" />
                        Preserva a cor original
                      </li>
                      <li className="flex items-center gap-3">
                        <img src="/media/institucional/check.png" alt="check" className="w-5 h-5 group-hover:hidden" />
                        <img src="/media/institucional/check_2.png" alt="check" className="w-5 h-5 hidden group-hover:block" />
                        Maior vida útil dos materiais
                      </li>
                      <li className="flex items-center gap-3">
                        <img src="/media/institucional/check.png" alt="check" className="w-5 h-5 group-hover:hidden" />
                        <img src="/media/institucional/check_2.png" alt="check" className="w-5 h-5 hidden group-hover:block" />
                        Aplicada em nossos difusores e componentes selecionados
                      </li>
                    </ul>
                  </div>
                </div>
            </div>
          </div>
        </div>

        {/* 5 - 3 containers lado a lado */}
        <div className="w-full py-16 px-4 bg-gray-50 flex justify-center">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl w-full">
            <div className="flex flex-col items-start p-8 bg-white rounded-2xl shadow-sm group hover:bg-[#890083] transition-colors duration-300">
              <img src="/media/institucional/5.jpg" alt="Produção Nacional" className="w-full h-48 object-cover rounded-xl mb-6 shadow-sm" />
              <h4 className="text-[#3c1053] group-hover:text-white text-xl font-bold mb-4 transition-colors">Produção nacional</h4>
              <p className="text-gray-600 group-hover:text-gray-100 text-base transition-colors text-left">
                Fabricamos no Brasil com controle total dos processos, garantindo qualidade, disponibilidade e suporte técnico especializado.
              </p>
            </div>
            <div className="flex flex-col items-start p-8 bg-white rounded-2xl shadow-sm group hover:bg-[#890083] transition-colors duration-300">
              <img src="/media/institucional/6.jpg" alt="Controle de Qualidade" className="w-full h-48 object-cover rounded-xl mb-6 shadow-sm" />
              <h4 className="text-[#3c1053] group-hover:text-white text-xl font-bold mb-4 transition-colors">Controle de qualidade</h4>
              <p className="text-gray-600 group-hover:text-gray-100 text-base transition-colors text-left">
                Cada lote é submetido a rigorosos testes de desempenho, segurança e durabilidade antes de chegar ao mercado.
              </p>
            </div>
            <div className="flex flex-col items-start p-8 bg-white rounded-2xl shadow-sm group hover:bg-[#890083] transition-colors duration-300">
              <img src="/media/institucional/7.jpg" alt="Portfólio Completo" className="w-full h-48 object-cover rounded-xl mb-6 shadow-sm" />
              <h4 className="text-[#3c1053] group-hover:text-white text-xl font-bold mb-4 transition-colors">Portfólio completo</h4>
              <p className="text-gray-600 group-hover:text-gray-100 text-base transition-colors text-left">
                Mais de 1000 produtos desenvolvidos para aplicações residenciais, comerciais, corporativas e industriais.
              </p>
            </div>
          </div>
        </div>

        {/* 6 - Produção Nacional + Icones + Imagem 8 */}
        <div className="w-full py-20 px-4 bg-white flex justify-center">
          <div className="max-w-6xl w-full flex flex-col md:flex-row gap-12 items-center">
            <div className="w-full md:w-1/2 flex flex-col text-left">
              <h2 className="text-[#3c1053] text-3xl md:text-4xl font-bold mb-6">Produção nacional</h2>
              <p className="text-gray-700 text-lg leading-relaxed mb-10 text-justify">
                Grande parte dos nossos produtos são produzidos em nossa fábrica localizada em Itajaí-SC. 
                Como indústria de iluminação LED nacional garantimos maior controle produtivo, agilidade logística 
                e padronização de qualidade.
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="flex flex-col items-center justify-center text-center gap-4 p-6 border border-gray-200 rounded-2xl group hover:bg-[#890083] transition-colors bg-white">
                  <img src="/media/institucional/rocket.png" alt="Desenvolvimento" className="w-12 h-12 object-contain group-hover:hidden" />
                  <img src="/media/institucional/rocket_2.png" alt="Desenvolvimento" className="w-12 h-12 object-contain hidden group-hover:block" />
                  <span className="text-[#3c1053] group-hover:text-white font-bold text-sm transition-colors">Desenvolvimento de novos produtos</span>
                </div>
                <div className="flex flex-col items-center justify-center text-center gap-4 p-6 border border-gray-200 rounded-2xl group hover:bg-[#890083] transition-colors bg-white">
                  <img src="/media/institucional/shield-check.png" alt="Controle" className="w-12 h-12 object-contain group-hover:hidden" />
                  <img src="/media/institucional/shield-check_2.png" alt="Controle" className="w-12 h-12 object-contain hidden group-hover:block" />
                  <span className="text-[#3c1053] group-hover:text-white font-bold text-sm transition-colors">Controle de qualidade</span>
                </div>
                <div className="flex flex-col items-center justify-center text-center gap-4 p-6 border border-gray-200 rounded-2xl group hover:bg-[#890083] transition-colors bg-white">
                  <img src="/media/institucional/factory.png" alt="Escala Industrial" className="w-12 h-12 object-contain group-hover:hidden" />
                  <img src="/media/institucional/factory_2.png" alt="Escala Industrial" className="w-12 h-12 object-contain hidden group-hover:block" />
                  <span className="text-[#3c1053] group-hover:text-white font-bold text-sm transition-colors">Produção em escala industrial</span>
                </div>
              </div>
            </div>
            <div className="w-full md:w-1/2 flex justify-end">
               <img 
                  src="/media/institucional/8.jpg" 
                  onError={(e) => { e.target.onerror = null; e.target.src="/media/institucional/8.png" }} 
                  alt="Fábrica Itajaí" 
                  className="w-full max-w-lg rounded-3xl object-cover shadow-lg" 
               />
            </div>
          </div>
        </div>

        {/* 7 - Segundo video nativo */}
        <div className="w-full overflow-hidden bg-black flex items-center justify-center">
          <video 
            autoPlay 
            loop 
            muted 
            playsInline 
            className="w-full h-auto block"
          >
            <source src="/media/institucional/fabrica.mp4" type="video/mp4" />
          </video>
        </div>

        {/* 8 - 2 containers lado a lado: Certificações */}
        <div className="w-full py-20 px-4 bg-gray-50 flex justify-center">
          <div className="max-w-6xl w-full grid grid-cols-1 md:grid-cols-2 gap-12">
            <div className="bg-white p-10 rounded-3xl shadow-sm border border-gray-100 flex flex-col items-center text-center group hover:bg-[#890083] transition-colors duration-300">
              <img src="/media/institucional/award.png" alt="ISO" className="w-20 h-20 object-contain mb-6 group-hover:hidden" />
              <img src="/media/institucional/award_2.png" alt="ISO" className="w-20 h-20 object-contain mb-6 hidden group-hover:block" />
              <h3 className="text-[#3c1053] text-2xl font-bold mb-4 group-hover:text-white transition-colors">Fábrica certificada ISO 9001:2015</h3>
              <p className="text-gray-600 group-hover:text-gray-100 transition-colors text-justify">
                Possuímos certificação ISO 9001:2015 assegurando excelência nos processos de produção e gestão.
              </p>
            </div>
            <div className="bg-white p-10 rounded-3xl shadow-sm border border-gray-100 flex flex-col items-center text-center group hover:bg-[#890083] transition-colors duration-300">
              <h3 className="text-[#3c1053] text-2xl font-bold mb-8 group-hover:text-white transition-colors">
                Qualidade certificada<br />pelos mais rigorosos<br />padrões globais
              </h3>
              <div className="flex gap-8 justify-center items-center">
                <img src="/media/institucional/10.png" alt="UL" className="h-16 object-contain group-hover:hidden" />
                <img src="/media/institucional/10_2.png" alt="UL" className="h-16 object-contain hidden group-hover:block" />
                <img src="/media/institucional/11.png" alt="Energy Star" className="h-16 object-contain" />
                <span className="text-[#3c1053] font-black text-4xl group-hover:text-white transition-colors">CEC</span>
              </div>
            </div>
          </div>
        </div>

        {/* 9 - Conheça nossos produtos container centralizado */}
        <div className="w-full py-16 px-4 flex flex-col items-center text-center bg-white max-w-6xl mx-auto">
          <h2 className="text-[#3c1053] text-3xl md:text-4xl font-bold mb-6">Conheça nossos produtos</h2>
          <p className="text-gray-600 max-w-2xl mb-10 text-center leading-relaxed">
            Possuímos um portfólio com <span className="font-bold text-gray-700">mais de 1.000 produtos</span> desenvolvidos para atender<br />
            diferentes aplicações com <span className="font-bold text-gray-700">performance, durabilidade e sofisticação</span>
          </p>
          <Link to="/produtos" className="flex items-center gap-3 bg-[#890083] text-white hover:text-white font-bold py-3 px-8 rounded-full shadow-md">
            <span>Acessar portfólio</span>
            <img src="/media/institucional/circle_2.png" alt="Acessar" className="w-5 h-5 object-contain" />
          </Link>
        </div>

        {/* 10 - 3 containers de produtos lado a lado */}
        <div className="w-full pt-4 pb-8 px-4 flex justify-center bg-white">
          <div className="flex flex-col md:flex-row gap-6 max-w-5xl w-full justify-center">
            <Link to="/categoria/embutido" className="w-full md:w-[32%] group flex flex-col items-center p-6 bg-gray-50 rounded-3xl hover:bg-[#890083] transition-colors duration-300 shadow-sm">
              <img src="/media/institucional/embutido.webp" alt="Embutidos" className="w-full aspect-square object-cover rounded-2xl mb-4" />
              <span className="text-[#3c1053] group-hover:text-white font-bold text-lg uppercase transition-colors">Embutidos</span>
              <span className="text-sm text-gray-500 group-hover:text-gray-200 text-center mt-2 transition-colors">Iluminação integrada ao forro</span>
            </Link>
            <Link to="/categoria/fitas-placas-led" className="w-full md:w-[32%] group flex flex-col items-center p-6 bg-gray-50 rounded-3xl hover:bg-[#890083] transition-colors duration-300 shadow-sm">
              <img src="/media/institucional/fitas.webp" alt="Fitas LED" className="w-full aspect-square object-cover rounded-2xl mb-4" />
              <span className="text-[#3c1053] group-hover:text-white font-bold text-lg uppercase transition-colors">Fitas LED</span>
              <span className="text-sm text-gray-500 group-hover:text-gray-200 text-center mt-2 transition-colors">Linhas contínuas de luz</span>
            </Link>
            <Link to="/categoria/lampada-direcional" className="w-full md:w-[32%] group flex flex-col items-center p-6 bg-gray-50 rounded-3xl hover:bg-[#890083] transition-colors duration-300 shadow-sm">
              <img src="/media/institucional/lampadas.webp" alt="Lâmpadas Direcionais" className="w-full aspect-square object-cover rounded-2xl mb-4" />
              <span className="text-[#3c1053] group-hover:text-white font-bold text-lg uppercase text-center transition-colors">Lâmpadas<br/>Direcionais</span>
              <span className="text-sm text-gray-500 group-hover:text-gray-200 text-center mt-2 transition-colors">Luz na direção certa</span>
            </Link>
          </div>
        </div>

        {/* 11 - 2 containers de produtos lado a lado */}
        <div className="w-full pb-20 px-4 flex justify-center bg-white">
          <div className="flex flex-col md:flex-row gap-6 max-w-5xl w-full justify-center">
            <Link to="/categoria/perfil-led" className="w-full md:w-[32%] group flex flex-col items-center p-6 bg-gray-50 rounded-3xl hover:bg-[#890083] transition-colors duration-300 shadow-sm">
              <img src="/media/institucional/perfis.webp" alt="Perfis" className="w-full aspect-square object-cover rounded-2xl mb-4" />
              <span className="text-[#3c1053] group-hover:text-white font-bold text-lg uppercase transition-colors">Perfis</span>
              <span className="text-sm text-gray-500 group-hover:text-gray-200 text-center mt-2 transition-colors">Iluminação linear com estilo</span>
            </Link>
            <Link to="/categoria/plafon" className="w-full md:w-[32%] group flex flex-col items-center p-6 bg-gray-50 rounded-3xl hover:bg-[#890083] transition-colors duration-300 shadow-sm">
              <img src="/media/institucional/plafons.webp" alt="Plafons" className="w-full aspect-square object-cover rounded-2xl mb-4" />
              <span className="text-[#3c1053] group-hover:text-white font-bold text-lg uppercase transition-colors">Plafons</span>
              <span className="text-sm text-gray-500 group-hover:text-gray-200 text-center mt-2 transition-colors">Minimalismo que ilumina</span>
            </Link>
          </div>
        </div>

        {/* 12 - CTA final */}
        <div className="w-full py-20 px-4 flex justify-center bg-gray-50">
          <div className="max-w-6xl w-full bg-white border border-gray-200 rounded-3xl p-16 flex flex-col items-center group hover:bg-[#890083] transition-colors duration-300 shadow-sm">
            <div className="flex flex-col items-start mb-10 max-w-xl">
              <img src="/media/institucional/lightbulb.png" alt="Ideia" className="w-16 h-16 mb-6 group-hover:brightness-0 group-hover:invert transition-all" />
              <h2 className="text-[#3c1053] group-hover:text-white text-3xl md:text-4xl font-bold mb-6 transition-colors text-left">
                Soluções completas para<br />o mercado profissional
              </h2>
              <p className="text-gray-600 group-hover:text-gray-100 text-lg opacity-90 leading-relaxed transition-colors text-left">
                Leve mais qualidade para seu portfólio. Conheça as soluções SAVE e 
                descubra por que milhares de profissionais confiam em nossa marca.
              </p>
            </div>
            <Link to="https://api.whatsapp.com/message/SRD47WM6CUQOK1?autoload=1&app_absent=0" className="flex items-center gap-3 bg-[#890083] text-white hover:text-white font-bold py-4 px-10 rounded-full shadow-lg border border-[#890083] group-hover:border-white transition-colors">
              <span>Fale com a gente</span>
              <img src="/media/institucional/send.png" alt="Enviar" className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Institucional;